import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  wrapFooter: {
    // maxWidth: '33.5%',
    marginTop: 127,
    position: 'relative',
  },
  itemFooter: {
    maxWidth: '33.5%',
  },

  textFooter: {
    fontSize: '0.8rem',
    letterSpacing: '0.32px',
    lineHeight: '150%',
    fontWeight: 300,
  },
  title: {
    fontSize: '0.8rem',
    letterSpacing: '0.32px',
    lineHeight: '150%',
    fontWeight: 400,
  },
}));

export default useStyles;
